import React from 'react'
import * as Dropdown from 'component/base/Form/Dropdown'

export const SeikyusakiKbn = props => {
  return <Dropdown.Static kubunKey='seikyusaki_kbn' {...props} />
}
